export default __webpack_public_path__ + "static/media/icon-storage-dark.6201ca13.svg";